import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  textField: {
    width: "100%",
    maxWidth: "100%",
  },
});

function InputText({
  label,
  required,
  value,
  onChange,
  maxLength,
  InputLabelProps,
  ...props
}) {
  const classes = useStyles();

  return (
    <TextField
      {...props}
      className={classes.textField}
      label={label}
      required={required}
      value={value || ""}
      onChange={onChange}
      inputProps={{
        maxLength,
      }}
      margin="dense"
      variant="outlined"
    />
  );
}

export default InputText;
